import moment from 'moment'
import Condition from './Condition'

export default class Question {


  constructor (obj) {
    this.id = obj.id
    this.q = obj.q
    this.info = obj.info
    this.a = obj.a
    this.dependencies = []
  }

  // --------------------------------------------------------------------------
  checkCondition (v, values) {
    if (this.a) {
      if (this.a.condition != null) {
        return Condition.evalCondition(this.a.condition, values, v)
      }

      if (this.a.min != null) {
        if (this.a.type === 'text' && v != null) {
          if (v.length < parseInt(this.a.min)) {
            return false
          }
        }

        if (this.a.type === 'array' && v != null) {

          if (this.a.min > 1 && v.length < parseInt(this.a.min)) {
            return false
          }
        }

        if (v == null) {
          return false
        }

      }

      if (this.a.max != null) {

        if (this.a.type === 'array' && v != null) {
          if (v.length > parseInt(this.a.max)) {
            return false
          }
        }

        if (this.a.type === 'date' && this.a.max === 'today') {
          if (moment().diff(moment(v, 'YYYY-MM-DD')) < 0) {
            return false
          }
        }

      }
    }
    

    return true
  }
  // --------------------------------------------------------------------------
  array (values) {
    if (this.a.type === 'array' || this.a.type === 'arraycomplete') {
      if ('values' in this.a) {
        if (this.a.values.length > 0) {
          let array = this.a.values.map(v => {
            if ('v' in v) {
              return v.v
            } else {
              return v
            }
          })
          return array
        } else {
          return this.a.values
        }
      } else if ('conditions' in this.a) {
        for (let c of this.a.conditions) {      
          if (Condition.evalCondition(c.condition, values, values[this.id])) {
            return c.values
          }
        }
      }
    }
    return null
  }
  // --------------------------------------------------------------------------
  hasFile () {
    return 'file' in this.a || 'files' in this.a
  }

 
  // --------------------------------------------------------------------------
  files (values) {
    let files
    if ('file' in this.a) {
      if (this.a.type === 'boolean' && values[this.id]) {
        this.a.file.id = this.id
        files = [this.a.file]  
      } else {
        files = [this.a.file]
      }
    } else if ('files' in this.a) {
      for (let i = 0; i < this.a.files.length; i++) {
        this.a.files[i].id = this.id + '_' + i 
      }
      files = this.a.files
    } else {
      files = []
    }
    
    let v = values[this.id]
    let filtered = files.filter(f => {
      return ('condition' in f) ? Condition.evalCondition(f.condition, values, v) : true
    })
    return filtered
  }
  // --------------------------------------------------------------------------

  checkFileCondition (values) {
    if (this.hasFile()) {
      if ('condition' in this.a.file) {
        let v = values[this.id]
        return Condition.evalCondition(this.a.file.condition, values, v)    
      }
      else {
        return true
      }
    }
    return false
  }

  // --------------------------------------------------------------------------
  dependsOn (qid) {
    if (this.a) {
      if (this.a.condition != null && this.a.condition.indexOf(qid) >= 0) {
        return true
      }
      if (this.a.conditions != null) {
        for (let c of this.a.conditions) {
          if (c.condition != null && c.condition.indexOf(qid) >= 0) {
            return true
          }
        }
      }
    }
    return false 
  }

  // --------------------------------------------------------------------------
  addDependency (qid) {
    this.dependencies.push(qid)
  }
  

}



// WEBPACK FOOTER //
// ./src/model/Question.js